const navdata = [
    {
        id: 1,
        title: "Label",
        icon: "label",
        nextUrl: "/label"    
    },
    {
        id: 2,
        title: "Archive",
        icon: "archive",
        nextUrl: "/archive"
    },
    {
        id: 3,
        title: "Notes",
        icon: "note_alt",
        nextUrl: "/notes"
    },
    {
        id: 4,
        title: "Trash",
        icon: "delete",
        nextUrl: "/trash"
    },
    {
        id: 5,
        title: "Focus",
        icon: "timelapse",
        nextUrl: "/focus"
    }
];

export default navdata;